import { render } from "./localizedText.vue?vue&type=template&id=6d376597&scoped=true&ts=true"
import script from "./localizedText.vue?vue&type=script&lang=ts"
export * from "./localizedText.vue?vue&type=script&lang=ts"

import "./localizedText.vue?vue&type=style&index=0&id=6d376597&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d376597"]])

export default __exports__